import { Button as AntButton, ButtonProps } from 'antd';
import { ButtonGroupProps } from 'antd/es/button';
import React from 'react';

import { strToIcon } from '../tools/icon';

const ButtonFn = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { icon, ...args } = props;
  return <AntButton {...args} ref={ref} icon={strToIcon(icon)} />;
});

export const Button = Object.assign(ButtonFn, {
  Group: AntButton.Group,
});


export type { ButtonGroupProps, ButtonProps };
